import type { ExpenseVatItemInput } from "@src/__generated__/urql-graphql";
import { type NumberModel, PercentModel } from "@src/utils/models";
import { FieldState, FormState } from "formstate";

export class ExpenseVatItemForm {
  amount_in_currency: FieldState<NumberModel>;
  vat_percent_informative: FieldState<number>;
  vat_in_currency: FieldState<number>;

  $: FormState<any>;

  constructor(
    amountInCurrency: NumberModel,
    vatPercentInformative: number,
    vatInCurrency?: number,
  ) {
    this.amount_in_currency = new FieldState(amountInCurrency);
    this.vat_percent_informative = new FieldState(vatPercentInformative);
    this.vat_in_currency = new FieldState(
      vatInCurrency ??
        new PercentModel(amountInCurrency.denominatedValue).percentOf(
          vatPercentInformative,
        ),
    );

    this.$ = new FormState([
      this.amount_in_currency,
      this.vat_percent_informative,
      this.vat_in_currency,
    ]);

    this.amount_in_currency.onDidChange(this.recalculateVatInCurrency);
    this.vat_percent_informative.onDidChange(this.recalculateVatInCurrency);
  }

  private recalculateVatInCurrency = () => {
    this.vat_in_currency.onChange(
      new PercentModel(this.vat_percent_informative.value).percentOf(
        this.amount_in_currency.value.denominatedValue,
      ),
    );
  };

  serialize(): ExpenseVatItemInput {
    return {
      amount_in_currency: this.amount_in_currency.value.denominatedValue,
      vat_in_currency: this.vat_in_currency.value,
      vat_percent_informative: this.vat_percent_informative.value,
    };
  }
}
